import { Skeleton, Stack } from '@mui/material';
import React from 'react';
import { PdfViewer } from '../../../../../components/new-design/layout/PdfViewer/PdfViewer';

type CustomerPortalPdfSectionProps = {
  isLoading: boolean;
  encodedPdf?: string;
};

export const CustomerPortalPdfSection: React.FC<CustomerPortalPdfSectionProps> = React.memo(
  ({ isLoading, encodedPdf }) => {
    return (
      <Stack
        sx={{
          backgroundColor: '#ECEDEE',
          padding: '32px',
          alignItems: 'center',
        }}
      >
        {isLoading ? (
          <Skeleton variant="rectangular" width="100%" height="100%" />
        ) : (
          encodedPdf && <PdfViewer base64EncodedPdf={encodedPdf} />
        )}
      </Stack>
    );
  },
);
